import { Video } from "lucide-react";

export default function RenderThumbnail({ render }) {
  const hasVideo = render.status === "completed" && Boolean(render.output_url);

  return (
    <div className="relative min-h-20 w-14 shrink-0 self-stretch overflow-hidden rounded-lg bg-slate-100">
      <div className="absolute inset-0 flex items-center justify-center" aria-hidden="true">
        <Video className="h-5 w-5 text-slate-400" />
      </div>
      {hasVideo ? (
        <img
          src={`/api/renders/${render.id}/thumbnail`}
          alt={`Thumbnail for render ${render.id}`}
          className="absolute inset-0 h-full w-full bg-slate-950 object-contain"
          loading="lazy"
          onError={(event) => { event.currentTarget.style.display = "none"; }}
        />
      ) : null}
    </div>
  );
}
